import { Component, OnInit, HostListener } from '@angular/core';
import { Location } from '@angular/common'
import { GlobalService } from '../../../services/global/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-install',
  templateUrl: './install.component.html',
  styleUrls: ['./install.component.css']
})
export class InstallComponent implements OnInit {

  constructor(
    private location: Location,
    public globals: GlobalService,
    private router: Router
  ) { }

  overrideInstall() {
    // this.globals.overrideInstallRequirement = true;
    localStorage.setItem('overrideInstallRequirement', new Date().toDateString());
    //Go to the main page (root) to force the Auth Guard to determine if the login instructions are needed or not...
    this.router.navigate([''], {skipLocationChange: true} );
  }
  

  ngOnInit() {
    //This is to force the URL to update from 'website/install' to 'website', so that isntalling PWA on iOS installs to 'website' rather than 'website/install'.
    this.location.replaceState('','');    
  }

}
